import { computed, ref, toValue, watch } from 'vue'

import { formatDollars } from '@/helpers/money'
import api from '@/store/api'

const sumOf = (rows, field) => rows.reduce((sum, row) => sum + (Number(row?.attributes?.[field]) || 0), 0)

export function revenueSummaryTiles({ net, gross, refunds }) {
  return [
    { label: 'Net', value: formatDollars(net) },
    { label: 'Gross', value: formatDollars(gross) },
    { label: 'Refunds', value: formatDollars(refunds) }
  ]
}

export const averageOrder = ({ net, orders }) => (orders > 0 ? formatDollars(net / orders) : '-')

export function useCustomerRevenue(customerId, apiRange) {
  const rows = ref([])
  const loading = ref(false)
  const failed = ref(false)
  let latestRequest = 0

  const load = async () => {
    const request = ++latestRequest
    const params = new URLSearchParams({ ...toValue(apiRange), conversation_user_pair_id: toValue(customerId) })
    loading.value = true
    try {
      const res = await api.call(
        'GET',
        `data_downloads/reports/revenue_report?${params.toString()}`,
        {},
        { receive: false }
      )
      if (request !== latestRequest) return
      rows.value = res?.data?.data ?? []
      failed.value = false
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching customer revenue:', error)
      if (request !== latestRequest) return
      rows.value = []
      failed.value = true
    } finally {
      if (request === latestRequest) loading.value = false
    }
  }

  const totals = computed(() => ({
    gross: sumOf(rows.value, 'gross_revenue'),
    refunds: sumOf(rows.value, 'refunds'),
    net: sumOf(rows.value, 'net_revenue'),
    orders: sumOf(rows.value, 'orders')
  }))

  watch(() => [toValue(customerId), toValue(apiRange)], load, { immediate: true })

  return { rows, loading, failed, totals }
}
